import { InsTypeNameEN as InsTypeNameEnEnum } from 'constants/enums/insTypeNameEN.enum';

export interface IProps {
  title: string;
  subTitle: string;
  desc?: string;
  textBlock?: string;
  navs?: IMainVisualNav[];
  newsAds?: IMainVisualNewsAds[];
  backgroundImages?: IMainVisualBackgroundImages[];
  scrollDownBtnText?: string;
  onScroll?: () => void;
}

/** 主視覺 props navs (圓形 elements) interface */
export interface IMainVisualNav {
  elemType: MainVisualNavElemTypeEnum;
  insType: InsTypeNameEnEnum;
  title: string;
  desc?: string;
  info?: string;
}

/** 主視覺 props newsAds (消息廣告) interface */
export interface IMainVisualNewsAds {
  title: string;
  content: string;
  table?: IMainVisualNewsAdsTable[];
}

/** 主視覺 props newsAds (消息廣告) 屬性 table interface */
export interface IMainVisualNewsAdsTable {
  title: string;
  content: string;
}

/** 主視覺 props backgroundImages (背景圖) interface */
export interface IMainVisualBackgroundImages {
  theme: InsTypeNameEnEnum;
  pcLeftImgPath: string;
  pcRightImgPath: string;
  mobileImgPath: string;
}

/** 主視覺 props navs 屬性 elemType enum */
export enum MainVisualNavElemTypeEnum {
  Basic = 'basic',
  Advanced = 'advanced'
}
